import React, { FC } from "react";

import { BulkExportProvider, SubscriptionProvider } from "../../../../bulkexport/providers";
import { SubscriptionsSettingsBulkExport } from "./SubscriptionsSettingsBulkExport";
import { ISubscriptionsSettingsBulkExportProps } from "./SubscriptionsSettingsBulkExport.types";

export const SubscriptionsSettingsBulkExportProvider: FC<ISubscriptionsSettingsBulkExportProps> = (props) => {
  const { value } = props;
  return (
    <BulkExportProvider>
      <SubscriptionProvider payload={value}>
        <SubscriptionsSettingsBulkExport {...props} />
      </SubscriptionProvider>
    </BulkExportProvider>
  );
};
